import { Observable } from "rxjs";
import { Store } from "@karma-games/angular-devkit/src/lib/extended-store";
import { selectRoundHistoryList } from "./round-history.selectors";

declare module "@ngrx/store/src/store" {
    interface Store<T> {
        subscribeRoundHistoryList(): Observable<number[]>;
    }
}

function subscribeRoundHistoryList(this: Store): Observable<number[]> {
    return this.select(selectRoundHistoryList);
}

Store.prototype.subscribeRoundHistoryList = subscribeRoundHistoryList;
